import type { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { SingleControlDialogComponent } from './single-control-dialog.component';
import type { SingleControlDialogData } from './single-control-dialog-data.interface';

const baseConfig: MatDialogConfig = {
  minWidth: '400px',
  height: 'auto',
  minHeight: '250px',
  maxWidth: '100vw',
  maxHeight: '100vh',
  disableClose: true,
};

export function openSingleControlDialog(
  data: SingleControlDialogData,
  matDialog: MatDialog,
  matDialogConfig?: MatDialogConfig,
): MatDialogRef<SingleControlDialogComponent> {
  return matDialog.open(SingleControlDialogComponent, {
    ...baseConfig,
    ...matDialogConfig,
    data,
  });
}
